import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SyncProvider } from "./context/SyncContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import InspectionForm from "./pages/InspectionForm";
import Admin from "./pages/Admin";
import AdminInspectionView from "./pages/AdminInspectionView";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-steel">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-steel">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Routing() {
  const { user, ready } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={ready && user ? <Navigate to="/" replace /> : <Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <Dashboard />
          </Protected>
        }
      />
      <Route
        path="/inspection/:id"
        element={
          <Protected>
            <InspectionForm />
          </Protected>
        }
      />
      <Route
        path="/admin"
        element={
          <AdminOnly>
            <Admin />
          </AdminOnly>
        }
      />
      <Route
        path="/admin/inspection/:id"
        element={
          <AdminOnly>
            <AdminInspectionView />
          </AdminOnly>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SyncProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routing />
        </BrowserRouter>
      </SyncProvider>
    </AuthProvider>
  );
}
